export const formatDate = (dateString: string): string => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const [year, month, day] = dateString.split('-').map(Number);

  if (!year || !month || !day) {
    throw new Error('Invalid date format. Expected yyyy-mm-dd.');
  }

  const monthName = months[month - 1];
  return `${monthName} ${day}, ${year}`;
};

export const getDateDifference = (date: string): string => {
  const MS_IN_A_DAY = 1000 * 60 * 60 * 24;

  const today = new Date();
  const inputDate = new Date(date);

  // Normalize both to midnight local time
  today.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);

  const d1 = today.getTime();
  const d2 = inputDate.getTime();

  if (isNaN(d1) || isNaN(d2)) {
    throw new Error('Invalid date format. Dates must be in yyyy-mm-dd format.');
  }

  const differenceInMs = d1 - d2;
  const differenceInDays = Math.round(Math.abs(differenceInMs) / MS_IN_A_DAY);

  if (differenceInDays === 0) {
    return 'Today';
  } else if (differenceInDays === 1) {
    return 'Yesterday';
  } else if (differenceInDays < 7) {
    return `${differenceInDays} Days Ago`;
  } else if (differenceInDays < 14) {
    return 'Last Week';
  } else if (differenceInDays < 30.44) {
    const weeks = Math.floor(differenceInDays / 7);
    return `${weeks} Weeks Ago`;
  } else if (differenceInDays < 61) {
    return 'Last Month';
  } else if (differenceInDays < 365.25) {
    const months = Math.floor(differenceInDays / 30.44);
    return `${months} Months Ago`;
  }
  return 'Over a Year Ago';
};

export const parseDateOnlyToLocalDate = (
  value?: string | null,
): Date | null => {
  if (!value) return null;

  const datePart = value.slice(0, 10); // handles both YYYY-MM-DD and ISO strings
  const [year, month, day] = datePart.split('-').map(Number);

  if (!year || !month || !day) return null;

  return new Date(year, month - 1, day); // local date, no timezone shift
};

export const formatLocalDateToDateOnly = (date: Date | null): string => {
  if (!date) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
